import store from "../store/index";

export default {
  handleError(error, options = {}) {
    const { skipLogout = false } = options;
    // A paused token refuses every order with this named error. Say so in the server's words, whatever
    // the status code, rather than letting a generic branch below turn it into "contact support".
    const data = error?.response?.data;
    // The API sends it as `code` (status 409); `name` is kept for older response shapes.
    if ([data?.code, data?.error?.name, data?.name].includes("TOKEN_TRADING_HALTED_ERROR")) {
      return store.dispatch(
        "showToast",
        {
          description: data?.error?.message || data?.message || "Trading in this asset is paused.",
          display: true,
          type: "error",
        },
        { root: true }
      );
    }

    if (error && error.response && error.response.status === 500) {
      return store.dispatch(
        "showToast",
        {
          description: "An error occurred, please contact support",
          display: true,
          type: "error",
        },
        { root: true }
      );
    }
    if (error.message === "Network Error") {
      store.dispatch(
        "showToast",
        {
          description:
            "Connection not established, please check your internet connection",
          display: true,
          type: "error",
        },
        { root: true }
      );
    } else if (error.message === "Ensure to select documents for all!") {
      store.dispatch(
        "showToast",
        {
          description: error.message,
          display: true,
          type: "error",
        },
        { root: true }
      );
    } else if (error.message === "Request failed with status code 401") {
      if (!skipLogout) {
        store.dispatch("logout");
      }
      store.dispatch("showToast", {
        description: error?.response?.data?.message || "Your session has expired.",
        display: true,
        type: "error",
      });
    } else if (error.message === "timeout of 0ms exceeded") {
      store.dispatch("showToast", {
        description: error.message,
        display: true,
        type: "error",
      });
    }
    //  else if (error.message) {
    //   store.dispatch(
    //     "showToast",
    //     {
    //       description: error.message,
    //       display: true,
    //       type: "error",
    //     },
    //     { root: true }
    //   );
    // }
    // Guarded: a non-axios error (a TypeError thrown inside an action's try block) has no
    // `response`, and reading through it here threw a second error that masked the first.
    else if (error?.response?.data?.error?.message) {
      store.dispatch(
        "showToast",
        {
          description: error.response.data.error.message,
          display: true,
          type: "error",
        },
        { root: true }
      );
    } else {
      // Final fallback. Anything reaches here, including errors that are not axios errors at
      // all — a TypeError thrown inside an action's try block has no `response`, and reading
      // through it unguarded threw a SECOND error that masked the first in the console.
      const description =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        error?.message ||
        "Something went wrong, please try again.";

      store.dispatch(
        "showToast",
        { description, display: true, type: "error" },
        { root: true }
      );
    }
  },
};
